<template>
        <div class="grid-container">
            <div class="grid-x" v-if="researcherStudies && studies">
                <div class="cell">
                    <br />
                    <p>&nbsp;</p>
                </div>
                <div class="table__wrapper cell">
                    <table class="table table--scientists">
                        <caption><h2>{{labels.studiesByResearcher}}</h2></caption>
                        <thead>
                            <tr>
                                <th>{{labels.researcher}}</th>
                                <th>{{labels.inProgress}}</th>
                                <th>{{labels.readyForPublication}}</th>
                                <th>{{labels.publishedInternally}}</th>
                                <th>{{labels.published}}</th>
                                <th>{{labels.depublished}}</th>
                                <th>{{labels.total}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                                tabindex="0" 
                                @click="showResearchers = !showResearchers" 
                                @keyup.enter="showResearchers = !showResearchers" 
                                :class="{'table__toggler--open': showResearchers}">
                                <td>
                                    <span v-if="showResearchers" class="table__minus"></span>
                                    <span v-else class="table__plus"></span>
                                    <span>{{labels.total}}</span>
                                </td>
                                <td>{{researcherStudies.totalInProgress }}</td>
                                <td>{{researcherStudies.totalReadyForPublication}}</td>
                                <td>{{researcherStudies.totalPublishedInternal}}</td>
                                <td>{{researcherStudies.totalPublished}}</td>
                                <td>{{researcherStudies.totalUnPublished}}</td>
                                <td>{{researcherStudies.total}}</td>
                            </tr>
                            <tr v-if="showResearchers" v-for="(researcher, k) of researcherStudies.researchers" :key="k" tabindex="0">
                                <td>{{researcher.name}}</td>
                                <td>{{researcher.inProgress}}</td>
                                <td>{{researcher.readyForPublication}}</td>
                                <td>{{researcher.publishedInternal}}</td>
                                <td>{{researcher.published}}</td>
                                <td>{{researcher.unPublished}}</td>
                                <td>{{researcher.total}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            <div class="button__filter button-group cell hide-for-print">
                <button :disabled="busy" @click="setOverviewType('targetgroup', labels.targetGroup, labels.studiesByTargetGroup)" @keyup.enter="setOverviewType('targetgroup', labels.targetGroup, labels.studiesByTargetGroup)" class="button" :class="{'outline': sortedBy !== 'targetgroup'}">{{labels.targetGroups}}</button>
                <button :disabled="busy" @click="setOverviewType('activity', labels.intervention, labels.studiesByIntervention)" @keyup.enter="setOverviewType('activity', labels.intervention, labels.studiesByIntervention)" class="button" :class="{'outline': sortedBy !== 'activity'}">{{labels.interventions}}</button>
                <button :disabled="busy" @click="setOverviewType('effect', labels.effect, labels.studiesByEffect)" @keyup.enter="setOverviewType('effect', labels.effect, labels.studiesByEffect)" class="button" :class="{'outline': sortedBy !== 'effect'}">{{labels.effects}}</button>
            </div>

            <div class="table__wrapper cell">
                <table class="table table--overview">
                    <caption><h2>{{ captionLabel || labels.studiesByTargetGroup }}</h2></caption>
                    <thead>
                        <tr class="table__row--visible">
                            <th>{{colLabel || labels.targetGroup}}</th>
                            <th>{{labels.total}}</th>
                        </tr>
                    </thead>
                    <tbody v-if="showOverViewTable">
                        <template v-for="(lev1Item, k) of studies">
                            <tr tabindex="0" :key="'k' + k" v-if="lev1Item.groupName" class="table__row--visible" 
                            @click="lev1Item.open = !lev1Item.open" 
                            @keyup.enter="lev1Item.open = !lev1Item.open">
                                <td>
                                    <span v-if="lev1Item.items.length > 0">
                                        <span v-if="lev1Item.open" class="table__minus"></span>
                                        <span v-else class="table__plus"></span>
                                    </span>
                                    {{lev1Item.groupName}}</td>
                                <td>&nbsp;</td>
                            </tr>
                            <template v-for="(lev2Item, l) of lev1Item.items">
                                <tr :tabindex="lev1Item.open ? '0' : '-1'" :key="'l' + l" v-if="lev2Item.name" :class="{'table__row--visible': lev1Item.open}" 
                                @click="lev2Item.open = !lev2Item.open" 
                                @keyup.enter="lev2Item.open = !lev2Item.open" class="table__row-indent1">
                                    <td>
                                        <span v-if="lev2Item.items.length > 0">
                                            <span v-if="lev2Item.open" class="table__minus"></span>
                                            <span v-else class="table__plus"></span>
                                        </span>
                                        {{lev2Item.name}}
                                    </td>
                                    <td>{{lev2Item.total}}</td>
                                </tr>
                                <tr :tabindex="lev2Item.open ? '0' : '-1'" v-for="(lev3Item, m) of lev2Item.items" :key="'m' + m" v-if="lev3Item.name" :class="{'table__row--visible': lev2Item.open && lev1Item.open}" class="table__row-indent2">
                                    <td>{{lev3Item.name}}</td>
                                    <td>{{lev3Item.total}}</td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="grid-x" v-else>
            <div class="cell">
                <div class="loader__wrapper loader__wrapper--loading loader__wrapper--md">
                    <div class="loader">
                        <div class="loader__circle"></div>
                        <div class="loader__text">{{labels.loadingStudyOverview}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'studyOverview',
    data() {
        return {
            showResearchers: false,
            sortedBy: 'targetgroup',
            showOverViewTable: false,
            colLabel: null,
            captionLabel: null,
            busy: false
        }
    },
    computed: {
        studies() {
            return this.$store.state.studyOverview
        },
        researcherStudies() {
            return this.$store.state.studyOverviewResearchers
        },
        labels() {
            return this.$store.state.labels['pages.mypage.studyoverview'] || { };
        }
    },
    methods: {
        setOverviewType(type, col, cap) {
            this.captionLabel = cap;
            this.colLabel = col;
            this.showOverViewTable = false;
            this.busy = true;
            this.sortedBy = type;
            this.$store.dispatch('getStudyOverview', { name: type }).then(res => {
                this.showOverViewTable = true;
                this.busy = false;
            });
        }
    },
    mounted() {
        this.$store.dispatch('getLabels', { label: 'pages.mypage.studyoverview' });
        this.$store.dispatch('getStudyOverviewResearchers');
        this.setOverviewType(this.sortedBy);
    }
}

</script>



// WEBPACK FOOTER //
// src/components/my-pages/StudyOverview.vue